// extracted by mini-css-extract-plugin
export default {"container":"QK6+P","giftWrapper":"JD9RS","heading":"_2g5yX","gift":"EHemC","title":"NDsFa","sold":"m0tlt","logo":"_9m1oL"};